import React, { useCallback } from 'react'
import { localStorageInstance } from '../../utils/localStorage';
import { CustomButton } from '../Button/Button';

function RemindMeLater({ handleClose }) {

  const setTime = useCallback(() => {
    const now = Math.floor(Date.now() / 1000); // Get current time in seconds (epoch)
     localStorageInstance.setItem({ key: "worklog-remind", value: now });
    handleClose();
  }, [handleClose]);

  return (
    <CustomButton
      onClick={setTime}
      //   disabled={loading}
      fullWidth
      variant="contained"
      className="confirmation-action-btn remind-me-later remind-me-later-btn"
    >
      I'm on it (remind me in 1 hr if I forget)
    </CustomButton>
  );
}

export default React.memo(RemindMeLater)